import React from 'react'
import Complete from './play/Complete'
import Word from './play/Word'
import Letters from './play/Letters'
import {useGameState} from '../hooks/useGameState'
import Wrapper from './layout/Wrapper'
import Progress from './play/Progress'
import CreateButton from './play/CreateButton'

function Play() {
  const {error, isComplete, isLost} = useGameState()

  if (error) {
    return (
      <Wrapper>
        <p>Sorry, this game URL is invalid :(</p>
      </Wrapper>
    )
  }

  if (isComplete) {
    return (
      <Wrapper>
        <Progress/>
        <Complete/>
        <p>
          <CreateButton />
        </p>
      </Wrapper>
    )
  }

  if (isLost) {
    return (
      <Wrapper>
        <Progress/>
        <p>
          <Word/>
        </p>
        <p>
          <CreateButton />
        </p>
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      <Progress/>
      <p>
        <Word/>
      </p>
      <p>
        <Letters/>
      </p>
    </Wrapper>
  )
}


export default Play